<template>
  <div
    class="loading-element fixed top-0 left-0 z-10 h-screen w-screen flex items-center justify-center transition-all duration-1000 ease-in-out"
    :class="{ 'opacity-0': loaded, 'opacity-100': !loaded, hidden: hidden }"
  >
    <div
      class="absolute top-0 left-0 z-20 h-full w-full bg-nucleus-lightestBlue opacity-80"
    ></div>
    <div class="relative z-30 text-3xl text-gray-600 capitalize animate-pulse">
      {{ message }}
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({
  props: {
    loaded: Boolean,
    message: String,
  },
  data() {
    return {
      hidden: false,
    };
  },
  watch: {
    loaded: function (newVal) {
      if (newVal) this.hide();
      if (newVal === false) this.hidden = false;
    },
  },
  methods: {
    hide() {
      setTimeout(() => {
        this.hidden = true;
      }, 500);
    },
  },
})
export default class HeaderMini extends Vue {}
</script>
